import { render } from "./LoginComposition.vue?vue&type=template&id=13190f3c"
import script from "./LoginComposition.vue?vue&type=script&lang=js"
export * from "./LoginComposition.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__